module.exports = "https://beta.voredev.ru/assets/index/quick-search-cdd187ab3104d50b53124a0c525185f7.png";